module.exports = __webpack_public_path__ + "static/media/By_youself.b08119d6.svg";